import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import heartbeatManager from '../utils/heartbeat';
import './TopNavbar.css';

export default function TopNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [equityMenuOpen, setEquityMenuOpen] = useState(false);
  const avatarRef = useRef(null);
  const equityRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    function handleClickOutside(e) {
      if (avatarRef.current && !avatarRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
      if (equityRef.current && !equityRef.current.contains(e.target)) {
        setEquityMenuOpen(false);
      }
    }
    if (menuOpen || equityMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen, equityMenuOpen]);

  const handleLogout = () => {
    // 确认退出
    if (!window.confirm('确定要退出登录吗？')) {
      return;
    }
    
    // 停止心跳机制
    console.log('用户登出，停止心跳机制');
    heartbeatManager.stop();
    
    // 清除所有登录相关的本地存储
    localStorage.removeItem('token');
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('avatar');
    localStorage.removeItem('accountNickName');
    localStorage.removeItem('hasEditAllPermission');
    localStorage.removeItem('lastActivity');
    
    // 清除微信相关数据
    localStorage.removeItem('wechatUser');
    localStorage.removeItem('wechatToken');
    localStorage.removeItem('isWechatLoggedIn');
    
    // 设置退出登录标识，防止自动授权
    localStorage.setItem('manualLogout', 'true');
    
    // 关闭下拉菜单
    setMenuOpen(false);
    
    // 跳转到登录页
    navigate('/login');
  };

  const avatar = localStorage.getItem("avatar");
  const nickname = localStorage.getItem("accountNickName");

  return (
    <div className="top-navbar">
      <div className="navbar-left">
        <img src="/logo192.png" alt="logo" className="navbar-logo" />
        <span className="navbar-title">MicroForm</span>
        <span className="navbar-menu-item" onClick={() => navigate('/forms')} style={{marginLeft: 24, cursor: 'pointer'}}>表单列表</span>
        {/* <span className="navbar-menu-item" onClick={() => navigate('/lottery-activity')} style={{marginLeft: 24, cursor: 'pointer'}}>抽奖</span> */}
        <span className="navbar-menu-item" onClick={() => navigate('/sign-in-sheet')} style={{marginLeft: 24, cursor: 'pointer'}}>签到表</span>
        <span className="navbar-menu-item" onClick={() => navigate('/black-card-management')} style={{marginLeft: 24, cursor: 'pointer'}}>黑卡管理</span>
        <span className="navbar-menu-item" onClick={() => navigate('/feedback-management')} style={{marginLeft: 24, cursor: 'pointer'}}>活动反馈管理</span>
        <div
          ref={equityRef}
          style={{ position: 'relative', marginLeft: 24 }}
          className="navbar-menu-item"
          onClick={() => setEquityMenuOpen(v => !v)}
        >
          商城权益
          <span style={{ marginLeft: 4, fontSize: 10 }}>▾</span>
          {equityMenuOpen && (
            <div className="navbar-dropdown" style={{ top: 40, left: 0, right: 'auto' }}>
              <div
                className="dropdown-item"
                onClick={() => {
                  setEquityMenuOpen(false);
                  navigate('/black-card-privilege-activation');
                }}
              >
                VIP权益激活
              </div>
              <div
                className="dropdown-item"
                onClick={() => {
                  setEquityMenuOpen(false);
                  navigate('/member-benefit-list');
                }}
              >
                会员列表
              </div>
              <div
                className="dropdown-item"
                onClick={() => {
                  setEquityMenuOpen(false);
                  navigate('/house-inspection-management');
                }}
              >
                验房管理
              </div>
              <div
                className="dropdown-item"
                onClick={() => {
                  setEquityMenuOpen(false);
                  navigate('/benefit-card-write-off-management');
                }}
              >
                核销列表
              </div>
              <div
                className="dropdown-item"
                onClick={() => {
                  setEquityMenuOpen(false);
                  navigate('/merchant-store-info-management');
                }}
              >
                商家列表
              </div>
            </div>
          )}
        </div>
        {/* <span className="navbar-menu-item" onClick={() => navigate('/webhook-chat')} style={{marginLeft: 24, cursor: 'pointer'}}>话术生成-测试</span> */}
        {/* <span className="navbar-menu-item" onClick={() => navigate('/webhook-upload')} style={{marginLeft: 24, cursor: 'pointer'}}>活动策划生成-测试</span> */}
        <span className="navbar-menu-item" onClick={() => navigate('/parttime')} style={{marginLeft: 24, cursor: 'pointer'}}>兼职数据</span>
      </div>
      <div className="navbar-right">
        <span
          className="navbar-avatar"
          ref={avatarRef}
          onClick={() => setMenuOpen(v => !v)}
          style={{ cursor: 'pointer', position: 'relative' }}
        >
          {avatar
            ? <img src={avatar} alt="头像" style={{width: "100%", height: "100%", borderRadius: "50%"}} />
            : (nickname?.[0] || "U")}
          {menuOpen && (
            <div className="navbar-dropdown">
              <div className="dropdown-item">个人主页</div>
              <div className="dropdown-item" onClick={() => navigate('/account-settings')}>账号设置</div>
              <div className="dropdown-item" onClick={handleLogout}>退出</div>
            </div>
          )}
        </span>
      </div>
    </div>
  );
} 